import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { usePostCreatePaymentTermMutation,useTotalModeOfPaymentListMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";

const CreateForm = () => {
  const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [CreatePaymentTerm] = usePostCreatePaymentTermMutation();
  const [ModeOfPaymentListApi] = useTotalModeOfPaymentListMutation();

  // tab1
    const [ModeofPayment_list, setModeofPayment_list] = useState([]);
  const [select_ModeofPayment, setselect_ModeofPayment] = useState("");
  const [InvoicePortion, setInvoicePortion] = useState("");
  const [DueDateBasedOn, setDueDateBasedOn] = useState("");
  const [PaymentTermName, setPaymentTermName] = useState("");
  const [CreditDays, setCreditDays] = useState("");
  
      

  

  const [DiscountType, setDiscountType] = useState("");
  const [Discount, setDiscount] = useState("");
  const [DiscountValidityBasedOn, setDiscountValidityBasedOn] = useState("");
  const [DiscountValidity, setDiscountValidity] = useState("");
  const [Description, setDescription] = useState("");

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   PaymentTermName: false,
   ModeofPayment: false,
      DueDateBasedOn: false,
      CreditDays: false,
      Discount: false,
      DiscountType: false,
  });

  useEffect(() => {
     const getItemModeofPayment = async () => {
        const ItemModeofPaymentApiData = await ModeOfPaymentListApi()
        setModeofPayment_list(ItemModeofPaymentApiData.data.data);
      }

   
 
    getItemModeofPayment();
    
  }, []);


  const handleSubmit = async () => {

 

    setFieldErrors({
      PaymentTermName: false,
      ModeofPayment: false,
      DueDateBasedOn: false,
      CreditDays: false,
      Discount: false,
      DiscountType: false,
    });

    let hasError = false;
    const newErrors = {
      ModeofPayment: !select_ModeofPayment,
      PaymentTermName: !PaymentTermName,
    };

    setFieldErrors(newErrors);
    hasError = Object.values(newErrors).some((error) => error);

    if (!PaymentTermName) {
      setptype("Error");
      setError("Please Select Payment Term Name.");
      setShowError(true);
      return;
    }
    if (!select_ModeofPayment) {
      setptype("Error");
      setError("Please Select Mode of Payment.");
      setShowError(true);
      return;
    }
    

   
  

  const payload = {
    mode_of_payment: select_ModeofPayment,
    invoice_portion: InvoicePortion,
    due_date_based_on: DueDateBasedOn,
    payment_term_name: PaymentTermName,
    credit_days: CreditDays,
    discount_type: DiscountType,
    discount: Discount,
    discount_validity_based_on: DiscountValidityBasedOn,
    discount_validity: DiscountValidity,
    description: Description,
  };

  console.log("create payment term payload:", payload);
    try {
      const response = await CreatePaymentTerm(payload); // RTK mutation or fetch

       function stripHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
}

if (response.error) {
  let errorMessage = "Creation failed";

  if (response.error.data && response.error.data._server_messages) {
    try {
      const serverMessages = JSON.parse(response.error.data._server_messages);
      if (Array.isArray(serverMessages) && serverMessages.length > 0) {
        const parsedMessage = JSON.parse(serverMessages[0]);
        errorMessage = parsedMessage.message || errorMessage;
      }
    } catch (e) {
      console.warn("Failed to parse _server_messages", e);
    }
  } else {
    errorMessage =
      response.error.data?.message ||
      response.error.data?.exception ||
      errorMessage;
  }

  // ✅ Strip any HTML tags like <strong> from the final error message
  errorMessage = stripHTML(errorMessage);

  setptype("Error");
  setError(errorMessage);
  setShowError(true);
  return;
}

      setpo_response(response.data);
      setError("Payment Term created successfully!");
      setptype("Success");
      setShowError(true);
      // Navigate after a short delay (e.g., 2 seconds)
      setTimeout(() => {
        navigate("/master/payment-term/payment-term-list"); // 🔁 Replace with your actual route
      }, 2000);
    } catch (err) {
      setError(err?.data?.message || "Unexpected error occurred.");
      setptype("Error");
      setShowError(true);
    }
  };
  return (
    <FormLayout
      title="New Payment Term"
      breadcrumbs={[
        { label: "Payment Term"},
        { label: "Payment Term List", url: "/master/payment-term/payment-term-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          <Button
            onClick={() => {}}
            to="/"
            state={po_response?.result}
            style={{ backgroundColor: "#fff", height: "28px" }}
            className="custom-btn-00989blue"
            display={finalstep ? "flex" : "none"}
          >
            + Create
          </Button>

          <Button
            className="custom-btn-bluecolor d-flex"
            iconName="BiCloudUpload"
            style={{ gap: "2px" }}
            iconSize={14}
          >
            Upload
          </Button>

          <Button
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrCopy"
            iconSize={12}
          >
            Duplicate
          </Button>

          <Button
            className="custom-btn-00989"
            onClick={handleSubmit}
            iconName="LuFilePlus2"
            style={{ gap: "2px", height: "28px" }}
            iconSize={12}
            display={finalstep ? "none" : "flex"}
          >
            {po_response.result ? "Submit" : "Save"}
          </Button>

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
              <span style={{ position: "relative", top: "-1px" }}>
                <GetIcon iconName="CgAttachment" size={12} />
              </span>
              <span className=" fw-semibold" style={{ color: "#391F84" }}>
                Attachments
              </span>
            </div>
          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                      ModeofPayment={{ ModeofPayment_list: ModeofPayment_list, setselect_ModeofPayment: setselect_ModeofPayment, select_ModeofPayment: select_ModeofPayment, Error: fieldErrors.ModeofPayment }}
                    DueDateBasedOn={{
                      DueDateBasedOn: DueDateBasedOn,
                      setDueDateBasedOn: setDueDateBasedOn,
                      DueDateBasedOn: DueDateBasedOn,
                      Error: fieldErrors.DueDateBasedOn,
                    }}
  
                    PaymentTermName={{
                      PaymentTermName: PaymentTermName,
                      setPaymentTermName: setPaymentTermName,
                      PaymentTermName: PaymentTermName,
                      Error: fieldErrors.PaymentTermName,
                    }}
                    CreditDays={{
                      CreditDays: CreditDays,
                      setCreditDays: setCreditDays,
                      CreditDays: CreditDays,
                      Error: fieldErrors.CreditDays,
                    }}
                     DiscountType={{
                      DiscountType: DiscountType,
                      setDiscountType: setDiscountType,
                      DiscountType: DiscountType,
                      Error: fieldErrors.DiscountType,
                    }}
                      
                     
                    InvoicePortion={{
                      InvoicePortion: InvoicePortion,
                      setInvoicePortion: setInvoicePortion,
                      InvoicePortion: InvoicePortion,
                      Error: fieldErrors.InvoicePortion,
                    }}
                    Discount={{
                      Discount: Discount,
                      setDiscount: setDiscount,
                      Discount: Discount,
                      Error: fieldErrors.Discount,
                    }}
                    DiscountValidity={{
                      DiscountValidity: DiscountValidity,
                      setDiscountValidity: setDiscountValidity,
                      DiscountValidity: DiscountValidity,
                      Error: fieldErrors.DiscountValidity,
                    }}
                     DiscountValidityBasedOn={{
                      DiscountValidityBasedOn: DiscountValidityBasedOn,
                      setDiscountValidityBasedOn: setDiscountValidityBasedOn,
                      DiscountValidityBasedOn: DiscountValidityBasedOn,
                      Error: fieldErrors.DiscountValidityBasedOn,
                    }}
                     
                    Description={{
                      Description: Description,
                      setDescription: setDescription,
                      Description: Description,
                      Error: fieldErrors.Description,
                    }}
                    
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default CreateForm;
